import React, { Component, createContext } from 'react'
import { VideoType } from '../../types'

interface Props {
  children: JSX.Element
}

interface ContextInterface {
  modalIsOpen: boolean
  openModal: (title: string, content: string, videos?: VideoType[]) => void
  closeModal: () => void
  title: string
  content: string
  videos?: VideoType[]
}

const ModalContext = createContext({} as ContextInterface)

const ModalConsumer = ModalContext.Consumer

class ModalProvider extends Component<Props, ContextInterface> {
  constructor(props: Props) {
    super(props)
    this.state = {
      modalIsOpen: false,
      openModal: this.openModal,
      closeModal: this.closeModal,
      title: '',
      content: '',
      videos: undefined
    }
  }

  openModal = (title: string, content: string, videos?: VideoType[]) => {
    this.setState({ modalIsOpen: true, title, content, videos})
  }

  closeModal = () => {
    this.setState({ modalIsOpen: false })
  }

  render() {
    const { children } = this.props

    return <ModalContext.Provider value={this.state}>{children}</ModalContext.Provider>
  }
}

export { ModalConsumer, ModalProvider }
